import { UtilsService } from '../utils';
import type { CreateAddToDatabaseTreeItemData, UpdateAddToDatabaseTreeItemData } from '@/types';
import { authorizedAPI } from '@/config/axios.config';

const utils = new UtilsService();

class AddToDatabaseTreeItemService {
    createTreeItem(data: CreateAddToDatabaseTreeItemData): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.post('/add-to-database-tree-item', data));
    }

    getAllTreeItems(): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.get('/add-to-database-tree-item'));
    }

    getTreeItemsByAddToDatabaseId(addToDatabaseId: string): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.get(`/add-to-database-tree-item/add-to-database/${addToDatabaseId}`));
    }

    getTreeItemById(id: string): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.get(`/add-to-database-tree-item/${id}`));
    }

    updateTreeItem(id: string, data: UpdateAddToDatabaseTreeItemData): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.patch(`/add-to-database-tree-item/${id}`, data));
    }

    deleteTreeItem(id: string): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.delete(`/add-to-database-tree-item/${id}`));
    }

    deleteAllByAddToDatabaseId(addToDatabaseId: string): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.delete(`/add-to-database-tree-item/add-to-database/${addToDatabaseId}/all`));
    }

    // Tree operations
    getFullHierarchy(addToDatabaseId: string): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.get(`/add-to-database-tree-item/add-to-database/${addToDatabaseId}/tree`));
    }

    getRootNodes(addToDatabaseId: string): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.get(`/add-to-database-tree-item/add-to-database/${addToDatabaseId}/roots`));
    }

    getChildren(parentId: string): Promise<any> {
        return utils.handleApiRequest(() => authorizedAPI.get(`/add-to-database-tree-item/${parentId}/children`));
    }
}

export const addToDatabaseTreeItemService = new AddToDatabaseTreeItemService();




